module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a4d91e3b83e7cbccaf4a4e2322b873f5.svg";